

































































































































































import { Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Audit from "./record_audit.vue";

@Component({
  components: {
    Audit
  }
})
export default class extends Mixins(MyList) {
  auditFormModalVisible: boolean = false;
  video: string = "";

  dispatchType = "agreement/records";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户", scopedSlots: { customRender: "username" } },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "升级申请id", dataIndex: "project_id" },
    {
      title: "协议标题/code",
      scopedSlots: { customRender: "agreement_title" }
    },
    { title: "同意时间", dataIndex: "agree_time" },
    { title: "客户端类型", scopedSlots: { customRender: "client_type" } },
    // { title: "记录生成时间", dataIndex: "created_time" },
    { title: "审核状态", scopedSlots: { customRender: "audit_status" } },
    { title: "审核时间", dataIndex: "audit_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  showAuditFormModal(id: number, video: string) {
    this.editId = id;
    this.video = video;
    this.auditFormModalVisible = true;
  }

  hideAuditFormModal() {
    this.loadData();
    this.auditFormModalVisible = false;
  }

  canAudit(agreement_code: string): boolean {
    if (
      agreement_code == "stadium_residence_agreement" ||
      agreement_code == "stadium_investment_agreement"
    ) {
      return true;
    }

    return false;
  }

  mounted() {
    this.loadData();
  }
}
